import { APIContext } from "../../types";
import { makePath } from "../../../../api/url";
import * as APITypes from "../../../../api/cur8/generated-types/v2/Api";
import { postJSON } from "../../request";

export type BillingApi = ReturnType<typeof createBillingAPIv2>;

export function createBillingAPIv2({ buildURL, fetchJSON }: APIContext) {
  function initiateCheckout(
    patientId: string,
    body: APITypes.InitiateCheckoutRequest
  ) {
    const path = makePath([
      "api",
      "v2",
      "patient",
      patientId,
      "cart",
      "initiate-checkout",
    ]);
    const url = buildURL(path);

    const request = postJSON(url, body);
    return fetchJSON<APITypes.InitiateCheckoutResponse>(request);
  }

  /**
   * Capture a pending card reader payment
   * @param patientId
   * @returns
   */
  function capturePendingCardPayment(patientId: string) {
    const path = makePath([
      "api",
      "v2",
      "patient",
      patientId,
      "stripe",
      "capture-pending-payment",
    ]);
    const url = buildURL(path);
    const request = postJSON(url, undefined);
    return fetchJSON<APITypes.BookingTokenV2>(request);
  }

  function initiateRefund(
    patientId: string,
    bookingTokenId: string,
    eTag: string
  ) {
    const path = makePath([
      "api",
      "v2",
      "patient",
      patientId,
      "booking",
      "token",
      bookingTokenId,
      "billing",
      "initiate-refund",
    ]);
    const url = buildURL(path);
    const request = postJSON(url, undefined);
    request.headers.set("If-Match", eTag);

    return fetchJSON<APITypes.BookingTokenV2>(request);
  }

  function stripeCharge({ patientId }: { patientId: string }) {
    const path = makePath([
      "api",
      "v2",
      "patient",
      patientId,
      "stripe",
      "charge",
    ]);

    const url = buildURL(path);
    const request = postJSON(url, undefined);

    return fetchJSON<APITypes.BookingTokenV2>(request);
  }

  function createStripeConnectionToken(
    body: APITypes.CreateStripeConnectionTokenRequest
  ) {
    const path = makePath([
      "api",
      "v2",
      "billing",
      "stripe",
      "connection-tokens",
    ]);
    const url = buildURL(path);
    const request = postJSON(url, body);
    return fetchJSON<APITypes.CreateStripeConnectionTokenResponse>(request);
  }

  return {
    capturePendingCardPayment,
    initiateCheckout,
    initiateRefund,
    stripeCharge,
    createStripeConnectionToken,
  };
}
